/* ON:PACE — video facade.
   Pairs with snippets/onpace-video.liquid. No <video> element exists in the
   page as delivered; this builds one when the reader asks for it (click) or
   when the section they are reading reaches the viewport (ambient).

   Deliberately dependency-free and idempotent: sections are re-rendered by the
   theme editor on every setting change, so init runs again on shopify:section
   events and must not double-build. */
(function () {
  'use strict';

  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* 11 assembly ships the same film in two cuts -- 9:16 for the phone, 16:9
     for the desktop -- as two files, because they are different edits and not
     one edit in a different box. Pick ONCE, here, at the moment the player is
     built: the poster already chose the same way through <picture>, and this
     keeps the promise the snippet exists for, that a film costs nothing until
     it is asked for. */
  var PHONE = window.matchMedia('(max-width:760px)');

  function sourcesFor(host) {
    var raw = host.dataset.sources || '[]';
    if (PHONE.matches && host.dataset.sourcesMobile) raw = host.dataset.sourcesMobile;
    try { return JSON.parse(raw) || []; } catch (e) { return []; }
  }

  function build(host, opts) {
    if (host.__opBuilt) return host.__opBuilt;
    var sources = sourcesFor(host);
    if (!sources.length) return null;

    var v = document.createElement('video');
    v.className = 'op-vid__el';
    v.setAttribute('playsinline', '');
    v.preload = 'auto';                    /* only now — it was never in the HTML */
    if (opts.muted) { v.muted = true; v.setAttribute('muted', ''); }
    if (opts.loop) v.loop = true;
    if (opts.controls) v.controls = true;

    var poster = host.querySelector('.op-vid__poster');
    if (poster && poster.currentSrc) v.poster = poster.currentSrc;

    sources.forEach(function (s) {
      var el = document.createElement('source');
      el.src = s.src;
      if (s.type) el.type = s.type;
      v.appendChild(el);
    });

    host.appendChild(v);
    host.classList.add('is-playing');
    host.__opBuilt = v;
    return v;
  }

  function play(v) {
    if (!v) return;
    var p = v.play();
    if (p && p.catch) p.catch(function () { /* autoplay refused — poster stays */ });
  }

  function init(scope) {
    var hosts = (scope || document).querySelectorAll('[data-op-video]');

    hosts.forEach(function (host) {
      if (host.__opWired) return;
      host.__opWired = true;

      /* 11 assembly: play it when it comes into view, but keep a way in for a
         reader who has asked for less motion -- for them it is click-to-play,
         because this film is the whole panel and `ambient` would leave them a
         poster and no control at all. */
      if (host.dataset.mode === 'auto' && !REDUCE.matches
          && 'IntersectionObserver' in window) {
        var ao = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) {
              if (host.__opBuilt) host.__opBuilt.pause();
              return;
            }
            play(build(host, { muted: true, loop: true, controls: false }));
          });
        }, { threshold: 0.25 });
        ao.observe(host);
        return;
      }

      if (host.dataset.mode === 'ambient') {
        /* built when the section is reached, not on load — and never at all
           under reduced motion, where an autoplaying loop is the whole problem */
        if (REDUCE.matches) return;
        if (!('IntersectionObserver' in window)) return;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) {
              if (host.__opBuilt) host.__opBuilt.pause();
              return;
            }
            play(build(host, { muted: true, loop: true, controls: false }));
          });
        }, { threshold: 0.25 });
        io.observe(host);
        return;
      }

      /* click mode — nothing happens until the reader asks */
      host.addEventListener('click', function () {
        var v = build(host, { muted: false, loop: false, controls: true });
        if (v) play(v);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  /* the theme editor re-renders a section on every setting change */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState !== 'loading') init(document);
})();
